import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { DatePipe } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { SearchLinkModule } from 'src/app/shared/search-link/search-link.module';
import { LocationListModule } from 'src/app/shared/location-list/location-list.module';

import { BreakpointService } from 'src/app/core/services/breakpoint.service';
import { ScrollToIdService } from 'src/app/core/services/scroll-to-id.service';
import { CountryInfoTextService } from '../../services/country-info-text.service';
import { HotelsProviderServiceService } from 'src/app/shared/used-components/hotels-booking-container/hotels-provider-service.service';

import { CityDetails } from 'src/app/core/types/models/city-details.model';
import { CityResponse } from 'src/app/core/types/models/city-response.model';
import { RegionDetails } from 'src/app/core/types/models/region-details.model';
import { VoiceMapResponse } from 'src/app/core/types/models/voice-map-response';
import { RegionResponse } from 'src/app/core/types/models/region-response.model';
import { OccasionGeniusResponse } from 'src/app/core/types/models/occasion-genius-response.model';

import { PageInfoComponent } from '../page-info';
import { IViatorCategories } from 'src/app/shared/used-components/viator/viator.component';
import { CityInfoPageMobileComponent } from '../../layout/mobile/city-info-page-mobile/city-info-page-mobile.component';
import { HOTEL_CLIENT } from 'src/app/shared/used-components/hotels-booking-container/hotels-booking-container.component';
import { CityInfoPageDesktopComponent } from '../../layout/desktop/city-info-page-desktop/city-info-page-desktop.component';

@Component({
  selector: 'app-city-info-page',
  templateUrl: './city-info-page.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LocationListModule,
    MatIconModule,
    MatMenuModule,
    SearchLinkModule,
    TranslateModule,
    NgxSkeletonLoaderModule,
    CityInfoPageDesktopComponent,
    CityInfoPageMobileComponent,
  ],
  providers: [
    CountryInfoTextService,
    DatePipe,
    {
      provide: HOTEL_CLIENT,
      useClass: HotelsProviderServiceService,
    },
  ],
})
export class CityInfoPageComponent extends PageInfoComponent {
  @Input({ required: true }) cityResponse: CityResponse = new CityResponse();
  @Input({ required: true }) cityDetails: CityDetails = new CityDetails();

  @Input({ required: true }) regionResponse: RegionResponse =
    new RegionResponse();
  @Input({ required: true }) regionDetails: RegionDetails = new RegionDetails();

  @Input({ required: true }) categoriesResponse: IViatorCategories = {};
  @Input({ required: true }) occasionGeniusResponse: OccasionGeniusResponse =
    new OccasionGeniusResponse({});
  @Input({ required: true }) voiceMapResponse: VoiceMapResponse =
    new VoiceMapResponse();

  public menuOpened: boolean[] = [];

  constructor(
    protected cdr: ChangeDetectorRef,
    protected scrollToIdService: ScrollToIdService,
    protected countryInfoTextService: CountryInfoTextService,
    protected readonly breakpointService: BreakpointService,
  ) {
    super(cdr, scrollToIdService);
  }
}
